import { LEGAL_HTML_BY_ID } from '../../constants/legalHtmlContent';
import './legal.css';

const PROSE_CLASSES = [
  'legal-prose',
  'prose max-w-none',
  'prose-headings:scroll-mt-6',
].join(' ');

const LegalDocumentContent = ({ document, className = '', omitTitle = false }) => {
  if (!document) return null;

  const html = LEGAL_HTML_BY_ID[document.id];
  if (!html) return null;

  return (
    <article className={`${className}${omitTitle ? ' legal-omit-title' : ''}`}>
      <div
        className={PROSE_CLASSES}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </article>
  );
};

export default LegalDocumentContent;
